import React from "react";

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <div className="bg-primary p-4 text-white">
      <div className="d-flex justify-content-between flex-wrap mb-2">
        <span className="mb-2 mb-md-0">
          Copyright &copy;{year} New-Drivers Education Inc.
        </span>
        <a href="https://new-drivers.ca" className="text-white">
          <u>Main Website</u>
        </a>
      </div>

      <span>
        Designed By{" "}
        <a
          href="https://bytewavestudios.ca"
          target="_blank"
          rel="noopener noreferrer"
          className="text-white"
        >
          <u>ByteWave Studios</u>
        </a>
      </span>
    </div>
  );
};

export default Footer;
